<div class="input" [ngClass]="validationClass">
  @if (name) {
    <span class="input-name">{{name}}</span>
  }
  @if (required) {
    <span class="required-red">*</span>
  }
  <div style="position:relative">
    @if (withImage) {
      <img src="../../../../content/images/Magnifier.svg" class="input-image" [ngStyle]="name && {'top': '30px'}" (click)="imageClicked.emit(value)">
    }
    <input name="autocomplete" matInput type="text" (blur)="onSaveModel()" inputPattern [inputTypePattern]="inputTypePattern" (focus)="onSaveState()"
      class="input-component" [ngModel]="value" (ngModelChange)="onModelChanged($event)" [placeholder]="placeholder" [disabled]="!!disabled"
      [maxLength]="maxTextLength" [matAutocomplete]="auto" #inputAutoCompleteRef>
    @if (showEye) {
      <img src='../../../../content/images/eye.svg' (click)="showHideValue()" class="show-hidden-value">
    }
    @if (hideValue && showEye && value) {
      <div class="hider">X</div>
    }
  </div>
</div>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="autoCompleteDisplayFn">
  @for (option of autoCompleteValues; track option) {
    <mat-option [value]="option" [disabled]="option.name==''" [innerHTML]="(option.valueHtml ? option.valueHtml : option.value) | safeHtml"></mat-option>
  }
</mat-autocomplete>
